import { useCallback, useRef } from 'react';

/**
 * Throttle a function to only be called once every `delay` milliseconds.
 * @param callback The function to throttle.
 * @param delay The delay in milliseconds.
 */
export function useThrottle(callback, delay) {
  const isThrottled = useRef(false);

  return useCallback(
    (...args) => {
      if (!isThrottled.current) {
        callback(...args);
        isThrottled.current = true;
        setTimeout(() => {
          isThrottled.current = false;
        }, delay);
      }
    },
    [callback, delay]
  );
}
